'use client';

import { ApolloError } from '@apollo/client';

import {
  GetResumeDocument,
  GetVacancyDocument
} from '@/__generated_graphql__/graphql';
import { AdTypeEnum, useDeleteAdMutation } from '@/__generated_graphql__/types';
import { mapTypenameToAdType } from '@/components/AdvertisePayments/AdvertisePayments.helpers';
import { useModal } from '@/components/AdvertisePayments/hooks/useModal';
import { CardAd } from '@/types';
import { logError } from '@/utils/log-error';

import { useCopyUrl } from './useCopyUrl';

export const useAdActions = (ad: CardAd | null) => {
  const [deleteAd] = useDeleteAdMutation();

  const mainModal = useModal();

  const onDeactivateOrDelete = async () => {
    if (!ad?.id) {
      console.warn('[Ad ID]: Cannot delete ad without valid ID.');
      return;
    }

    // eslint-disable-next-line no-underscore-dangle
    const adType = mapTypenameToAdType(ad.__typename);
    const isResume = adType === AdTypeEnum.Resume;

    try {
      await deleteAd({
        variables: {
          id: ad.id,
          adType: isResume ? AdTypeEnum.Resume : AdTypeEnum.Vacancy
        },
        refetchQueries: [
          {
            query: isResume ? GetResumeDocument : GetVacancyDocument,
            variables: { id: ad.id }
          }
        ],
        awaitRefetchQueries: true
      });
    } catch (error) {
      logError(error as ApolloError, {
        context: 'DeleteAd',
        adId: ad.id,
        adType: isResume ? 'Resume' : 'Vacancy'
      });
    }
  };

  const onActivate = () => {
    mainModal?.open?.();
  };

  const onPromote = () => {
    if (mainModal?.open) {
      mainModal.open();
    }
  };

  const onEdit = () => {
    // TODO: Implement edit
    console.log('edit');
  };

  const { toast, onCopy } = useCopyUrl();

  return {
    mainModal,
    toast,
    onDeactivateOrDelete,
    onActivate,
    onPromote,
    onEdit,
    onCopy
  };
};
